import { Close, Favorite, FavoriteBorderOutlined } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import React, { useRef } from "react";
import ConfettiButton from "../../../../../../../components/common/Confetti";
import { useTheme } from "../../../../../../../context/themeContext";
import useDiscover from "../../../../../../../hooks/useDiscover";
import useManageProjects from "../../../../../../../hooks/useManageProjects";
import styles from "./style.module.css";
import axios from "axios";
import { node_server } from "../../../../../../../constants";

function Top({
	project,
	isFavorite,
	setIsFavorite,
	showConfetti,
	addToFavorite,
	setShowConfetti,
}) {
	const { theme } = useTheme();
	const { handleCloseProject } = useDiscover(true);
	const { handleFavorite } = useManageProjects();
	const containerRef = useRef(null);

	const removeFromFavorite = async (id) => {
		setIsFavorite(false);
		handleFavorite(id, "remove");

		const response = await axios.post(
			`${node_server}/api/project-feed/${project.project_id}`,
			{
				is_favourite: false,
			},
			{
				withCredentials: true,
			},
		);
		if (response.status !== 200) {
			console.error("Error updating project feed:", response.data);
		}
	};

	return (
		<Box className={styles.top}>
			<Box className={styles.profile}>
				<Box
					className={styles.image}
					sx={{
						backgroundImage: `url(${project.profile_image})`,
						width: "48px",
						height: "48px",
						backgroundSize: "cover",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
					}}
				></Box>
				<Box className={styles.name}>
					<Typography
						variant="h6"
						sx={{
							color: theme.palette.darkgrey.darkgrey600,
							display: "-webkit-box",
							WebkitBoxOrient: "vertical",
							overflow: "hidden",
							WebkitLineClamp: 1,
							textOverflow: "ellipsis",
						}}
					>
						{project?.real_name}
					</Typography>
					<Typography
						variant="body2"
						sx={{
							color: theme.palette.darkgrey.darkgrey300,
						}}
					>
						{project?.nick_name}
					</Typography>
				</Box>
				<Box
					className={styles.options}
					sx={{
						"& .css-ixzp6w-MuiChip-root": {
							height: "auto",
						},
					}}
				>
					<Chip
						label={project.project_category}
						sx={{
							bgcolor:
								(project.project_category === "Brand" &&
									"#EC7508") ||
								(project.project_category === "Cause" &&
									"#05B240") ||
								(project.project_category === "Creator" &&
									"#09B999") ||
								(project.project_category === "Media" &&
									"#B90988"),
							color: "#FFF",
							fontSize: "12px",
							p: "4px 12px",
							"& .css-193rxqu-MuiChip-label": {
								lineHeight: "inherit",
							},
							height: "auto",
						}}
					/>
					<Box
						ref={containerRef}
						sx={{
							position: "relative",
							display: "flex",
							alignItems: "center",
						}}
					>
						<ConfettiButton
							showConfetti={showConfetti}
							setShowConfetti={setShowConfetti}
							containerRef={containerRef}
						/>
						{isFavorite ? (
							<Favorite
								sx={{ fill: theme.palette.primary.main }}
								onClick={() => {
									removeFromFavorite(project.project_id);
								}}
							/>
						) : (
							<FavoriteBorderOutlined
								sx={{ fill: theme.palette.primary.main }}
								onClick={() => {
									addToFavorite(project.project_id);
								}}
							/>
						)}
					</Box>
					<Close
						onClick={() => handleCloseProject(project)}
						sx={{
							color: theme.palette.darkgrey.darkgrey400,
							cursor: "pointer",
						}}
					/>
				</Box>
			</Box>
		</Box>
	);
}

export default Top;
